import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { browserHistory, Link } from 'react-router';
import _ from 'lodash';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withOnline from '../../common/withOnline';
import withTableName from '../../common/withTableName';
import withSetsSearch from '../../common/withSetsSearch';
import {
  ALPHANUMERIC, countImplantInstrument, onGoBack, renderAlphabetically, updateQuantityValue
} from '../../common/globals';
import Header from '../../components/Header';
import SetQuantity from '../../components/Models/SetQuantity';
import CaseType from '../../components/ManageCase/CaseType';
import SetRow from '../../components/Sets/SetRow';
import SetContents from '../../components/Sets/SetContents';
import {
  getECKits, getTableCaseByCaseId, updateTableWiseCaseByCaseId
} from '../../utils/db';
import { initAPIController, searchSets, updateCase } from '../../utils/utils';
import Bugsnag from '../../helpers/bugsnag';
import SaveExpressCareSetsModal from '../../components/Models/SaveExpressCareSetsModal';

class ExpressCareSets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sets: [],
      masterSetsGroup: [],
      setsGroup: [],
      instrumentCount: 0,
      implantCount: 0,
      selectedSet: {},
      search: '',
      isSearch: false,
      isSelected: false,
      isType: false,
      selectedType: '',
      isSetContents: false,
      deviceType: '',
      longPressItem: null,
      allSetsQty: {},
      selectedSetsQty: {},
      officeSets: [],
      selectedSetsCount: 0,
    };
    this.saveExpressCareSetsModal = null;
  }

  componentDidMount() {
    try {
      this.saveExpressCareSetsModal = new window.bootstrap.Modal(
        window.$('#saveExpressCareSetsModal')
      );
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSaveSets = async (quantity) => {
    try {
      const {
        selectedSet
      } = this.state;
      this._onEditSets(quantity, selectedSet);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onEditSets = (quantity, selectedSet) => {
    try {
      const { selectedSetsQty, isSelected } = this.state;
      selectedSetsQty[selectedSet.SetName] = quantity;

      const nonZeroCount = Object.values(selectedSetsQty).filter((value) => value !== 0).length;
      if (nonZeroCount === 0) {
        this.setState({
          isSelected: false
        }, () => {
          this._onFilter();
          this._updateINSIMP();
        });
      }

      this.setState({
        selectedSetsQty,
        selectedSet
      }, () => {
        if (isSelected) {
          this._onFilter();
        }
        this._updateINSIMP();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _updateINSIMP = () => {
    try {
      const { selectedSetsQty, sets } = this.state;
      // add qty to sets
      const updatedSets = updateQuantityValue(sets, selectedSetsQty, {});

      // Count implant/instrument
      const qtyImplantInstrument = countImplantInstrument(updatedSets);
      this.setState({
        instrumentCount: qtyImplantInstrument.instrumentQty,
        implantCount: qtyImplantInstrument.implantQty
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onFilter = () => {
    try {
      const {
        sets, selectedSetsQty, isSelected, deviceType, selectedType
      } = this.state;

      let data = [...sets];

      if (isSelected) {
        data = data.filter(
          // (item) => selectedSetsQty[item.SetName] >= 0
          (item) => selectedSetsQty[item.SetName] >= 0 && item.Quantity !== 0
        );
      }

      if (deviceType !== '') {
        // data = (data.filter((item) => item.DeviceType === deviceType));
        data = data.filter(
          (item) => item.DeviceType.includes(deviceType)
        );
      }

      if (selectedType !== '') {
        // data = (data.filter((item) => item.CaseType === selectedType));
        data = data.filter(
          (item) => item.CaseType.includes(selectedType)
        );
      }

      const setsGroup = renderAlphabetically(data, 'SetName');
      this.setState({
        setsGroup
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedSets = () => {
    try {
      const { isSelected } = this.state;
      this.setState({ isSelected: !isSelected }, () => this._onFilter());
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectDeviceType = (selectedDeviceType = '') => {
    try {
      let { deviceType } = this.state;
      deviceType = (deviceType === selectedDeviceType) ? '' : selectedDeviceType;
      this.setState({ deviceType }, () => { this._onFilter(); });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSearch = () => {
    try {
      const { isSearch, masterSetsGroup } = this.state;
      const { online, setSetsSearch } = this.props;
      if (online) {
        this.setState({ isSearch: !isSearch });
        if (isSearch) {
          setSetsSearch({});
          this.setState({
            search: '',
            setsGroup: masterSetsGroup
          });
        }
      } else {
        this.onlineAlertModal.show();
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSelectedCaseType = (selectedType) => {
    try {
      const { isType } = this.state;
      if (selectedType === '' || selectedType === undefined) {
        this.setState({ isType: !isType });
      } else {
        this.setState({ selectedType: selectedType.OptionName, isType: !isType },
          () => { this._onFilter(); });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCaseTypeClick = () => {
    try {
      const { isType, selectedType } = this.state;
      if (selectedType !== '') {
        this.setState({ selectedType: '' }, () => { this._onFilter(); });
      } else {
        this.setState({ isType: !isType });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onLongPress = (item) => {
    try {
      this.setState({ isSetContents: true, longPressItem: item });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSetBack = () => {
    try {
      this.setState({ isSetContents: false });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onExpressCareBack = () => {
    try {
      this.setState({ isType: false });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _getECKistsList = async () => {
    try {
      const { setsSearch } = this.props;
      const sets = await getECKits();
      const setsGroup = renderAlphabetically(sets, 'SetName');
      const search = setsSearch.hasOwnProperty('search') ? setsSearch.search : '';
      this.setState({
        setsGroup,
        masterSetsGroup: setsGroup,
        sets,
        search,
        allSetsQty: _.chain(sets)
          .keyBy('SetName')
          .mapValues('Quantity')
          .value(),
      }, () => {
        this._onSetSearch(search, () => {
          this._onFilter();
        });
        this._updateINSIMP();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSetSearch = async (search, callback = false) => {
    try {
      const {
        online, notify, setSetsSearch, setLoader
      } = this.props;
      const { masterSetsGroup } = this.state;

      this.setState({ search });

      const searchData = {
        search_term: search,
        set_type: 'eckit'
      };

      if (search.length >= 3) {
        if (online) {
          setLoader(true);
          if (this.apiController) {
            this.apiController.abort();
          }
          this.apiController = initAPIController();
          searchSets(searchData).then((response) => {
            const { status, data } = response;
            if (status) {
              data.map((value) => {
                value.ECSetDescription = value.ProductDescription;
              });
              const setsGroup = renderAlphabetically(data, 'SetName');
              this.setState({
                setsGroup,
                sets: data
              }, () => {
                callback && callback();
              });
              setSetsSearch({
                isSearch: true,
                setsGroup,
                search
              });
            }
            if (search.length < 3) {
              this.setState({
                setsGroup: renderAlphabetically(masterSetsGroup, 'SetName'),
                sets: masterSetsGroup
              }, () => {
                callback && callback();
              });
            }
          }).catch(() => {
            if (search.length < 3) {
              setSetsSearch({
                isSearch: true,
                setsGroup: renderAlphabetically(masterSetsGroup, 'SetName'),
                search
              });
              this.setState({
                setsGroup: renderAlphabetically(masterSetsGroup, 'SetName'),
                sets: masterSetsGroup
              }, () => {
                callback && callback();
              });
            }
          });
          setLoader(false);
        } else {
          notify({
            type: 'error',
            message: 'You must have as internet connection. Please check your connection and try again.'
          });
        }
      } else {
        if (this.apiController) {
          this.apiController.abort();
        }
        const sets = await getECKits();
        const setsGroup = renderAlphabetically(sets, 'SetName');
        setSetsSearch({
          isSearch: true,
          setsGroup,
          search: ''
        });
        this.setState({ setsGroup, sets }, () => {
          callback && callback();
        });
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onExpressCareSetsSave = async () => {
    try {
      const {
        params: { id }, notify, setLoader, goBack, tableName, setSetsSearch
      } = this.props;
      const { officeSets } = this.state;
      const caseDetail = await getTableCaseByCaseId(id, tableName);
      if (!caseDetail) {
        notify({ type: 'error', message: 'Case details not found.', time: 3 });
        browserHistory.push('/manage-cases');
        return false;
      }

      const comments = caseDetail.Comments && caseDetail.Comments != null
        ? caseDetail.Comments : '';
      caseDetail.Comments = officeSets.length > 0
        ? `${comments !== '' ? `${comments}\n` : ''}${officeSets.join(', ')}`
        : caseDetail.Comments;
      caseDetail.Submitted = '0';
      caseDetail.Synced = (caseDetail.Synced === '1' ? '0' : caseDetail.Synced);
      let newSets = [];
      caseDetail.case_sets.map((item) => {
        newSets.push({
          ...item,
          SetName: item.SetName,
          CasePlanID: item.CasePlanId,
          PreferenceName: item.PreferenceName
        });
      });
      newSets = _.orderBy(newSets, ['CasePlanID'], ['desc']);
      const newUsers = newSets.map(({
        CasePlanID, SetName, PreferenceName, Quantity
      }) => ({
        CasePlanID,
        SetName,
        PreferenceName,
        Quantity: Number(Quantity)
      }));
      caseDetail.selectedSets = newUsers;
      // Update API
      setLoader(true);
      updateCase(caseDetail).then(async (response) => {
        setLoader(false);
        const { status, message } = response;
        if (status) {
          // Update into local db
          caseDetail.Sync = 0;
          await updateTableWiseCaseByCaseId(caseDetail.RepCaseNo, caseDetail, tableName);
          if (message.length > 0) {
            // notify({ type: 'success', message });
          }
          setSetsSearch({});
          onGoBack(goBack);
          browserHistory.push(`/manage-case/${id}/sets`);
        } else {
          notify({ type: 'error', message });
        }
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRemoveQuantityZero = (removeQuantity, selectedSetsQty) => {
    try {
      const new_keys = Object.keys(selectedSetsQty).filter(
        (sets) => selectedSetsQty[sets] !== removeQuantity
      );
      const newObj = {};
      // eslint-disable-next-line no-return-assign
      new_keys.forEach((key) => newObj[key] = selectedSetsQty[key]);
      return newObj;
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSave = async () => {
    try {
      const { selectedSetsQty } = this.state;
      const { goBack, params: { id }, setSetsSearch } = this.props;
      setSetsSearch({});
      const setsQty = this._onRemoveQuantityZero(0, selectedSetsQty);
      const officeSets = [];
      Object.keys(setsQty).map((qKey) => {
        if (setsQty[qKey] > 1) {
          officeSets.push(`${qKey} (${setsQty[qKey]})`);
        } else {
          officeSets.push(`${qKey}`);
        }
      });
      let selectedSetsCount = 0;
      Object.keys(setsQty).map(
        // eslint-disable-next-line no-return-assign
        (key) => selectedSetsCount += Number(setsQty[key])
      );
      this.setState({
        officeSets, selectedSetsCount
      });
      if (officeSets.length > 0) {
        this.saveExpressCareSetsModal.show();
      } else {
        onGoBack(goBack);
        browserHistory.push(`/manage-case/${id}/sets`);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSetGoBack = () => {
    try {
      const { goBack, setSetsSearch } = this.props;
      setSetsSearch({});
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRemoveSearchValue = () => {
    try {
      this.setState({ search: '' });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      await this._getECKistsList();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { params: { id } } = this.props;
    const {
      setsGroup,
      selectedSetsQty,
      selectedSet,
      instrumentCount,
      implantCount,
      isSearch,
      isType,
      selectedType,
      isSetContents,
      longPressItem,
      allSetsQty,
      selectedSetsCount,
      search
    } = this.state;
    return (
      <section className={`list-section ${isSetContents ? 'resizer-class' : ''}`}>
        {
          <Header
            actionButton={
              (!isType && !isSetContents)
                ? { title: 'Save', onClick: this._onSave }
                : false
            }
            title={
              isType
                ? 'Type'
                : isSetContents
                  ? 'Set Contents'
                  : 'ExpressCare'
            }
            goBack={
              isType
                ? this._onExpressCareBack
                : isSetContents
                  ? this._onSetBack
                  : this._onSetGoBack
            }
          />
        }
        {
          !isSetContents
            ? (!isType)
              ? (
                <>
                  <section className="sets-section">
                    <div className="container">
                      <div className="top-block sticky-sets">
                        <div className="right-block">
                          <div className="row gx-2">
                            <div className="col text-center">
                              <p className="mb-0">INS: {instrumentCount} | IMP: {implantCount}</p>
                            </div>
                            <div className="col-auto align-self-center text-end">
                              <Link className="me-3"><i className="fas fa-search theme-color-yellow cursor-pointer" onClick={this._onSearch} /></Link>
                            </div>
                          </div>
                          {
                            (isSearch === true)
                              ? (
                                <div className="row gx-2">
                                  <div className="col-12">
                                    <div className="search-box show mt-2">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search"
                                        value={search}
                                        onChange={({ target: { value } }) => {
                                          this._onSetSearch(value, () => {
                                            this._onFilter();
                                          });
                                        }}
                                      />
                                      <span className="icon"><i className="fas fa-search" /></span>
                                      {/* { */}
                                      {/*  search !== undefined && search.length > 0 */}
                                      {/*    ? ( */}
                                      {/*      <span className="search-times-icon"> */}
                                      {/*        <i */}
                                      {/*          className="fas fa-times cursor-pointer" */}
                                      {/*          onClick={this._onRemoveSearchValue} */}
                                      {/*        /> */}
                                      {/*      </span> */}
                                      {/*    ) : '' */}
                                      {/* } */}
                                    </div>
                                  </div>
                                </div>
                              ) : ''
                          }
                        </div>
                      </div>
                      <div className="sets-list-blocks">
                        {setsGroup.length > 0
                          ? setsGroup.map((item, index) => (
                            <SetRow
                              temp={Math.random()}
                              setsQty={Object.assign(allSetsQty, selectedSetsQty)}
                              key={index}
                              onEditSets={this._onEditSets}
                              item={item}
                              index={index}
                              onLongPress={this._onLongPress}
                            />
                          )) : <p className="text-center mt-5">No sets match your filters</p>}
                      </div>
                    </div>
                    <ul className="list-unstyled right-filter mt-3">
                      {ALPHANUMERIC.map((name, index) => (
                        <li key={index}>
                          <a href={`/manage-case/${id}/sets/express-care-sets#${name.toLowerCase()}`} key={index}>{name}</a>
                        </li>
                      ))}
                    </ul>
                  </section>

                  <section className="sets-footer-section fixed-bottom">
                    <div className="sets-footer-inner">
                      <div className="container">
                        <div className="button-block">
                          <div className="row gx-2">
                            <div className="col-2">
                              <button
                                type="button"
                                className={`btn btn-sm btn-theme-alt btn-theme-outline-alt w-100 ${this.state.isSelected ? 'active' : ''}`}
                                value="isSelected"
                                onClick={this._onSelectedSets}
                              >Selected
                              </button>
                            </div>
                            <div className="col-2">
                              <button
                                type="button"
                                className={`btn btn-sm btn-theme-alt btn-theme-outline-alt w-100 ${selectedType ? 'active' : ''}`}
                                onClick={this._onCaseTypeClick}
                              >
                                {selectedType || 'Type'}
                              </button>
                            </div>
                            <div className="col">
                              <div className="btn-group w-100" role="group">
                                <button
                                  type="button"
                                  className={`btn btn-sm btn-theme-alt btn-theme-outline-alt w-50 ${this.state.deviceType === 'IMPLANT' ? 'active' : ''}`}
                                  value="IMPLANT"
                                  onClick={() => this._onSelectDeviceType('IMPLANT')}
                                >Implant
                                </button>
                                <button
                                  type="button"
                                  className={`btn btn-sm btn-theme-alt btn-theme-outline-alt w-50 ${this.state.deviceType === 'INSTRUMENT' ? 'active' : ''}`}
                                  value="INSTRUMENT"
                                  onClick={() => this._onSelectDeviceType('INSTRUMENT')}
                                >Instrument
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </>
              )
              : (
                <CaseType
                  onHideShowCaseType={this._onSelectedCaseType}
                />
              )
            : (
              <SetContents
                setName={longPressItem.SetName}
                ecSetsDescipriton={longPressItem.ECSetDescription}
                setType="eckit"
              />
            )
        }
        <SetQuantity
          qty={selectedSetsQty[selectedSet.SetName]}
          selectedSetName={selectedSet.SetName}
          onSaveSets={this._onSaveSets}
        />
        <SaveExpressCareSetsModal
          onSave={this._onExpressCareSetsSave}
          selectedSetsCount={selectedSetsCount}
        />
      </section>
    );
  }
}

const withForm = reduxForm({
  form: 'ExpressCareSetsForm',
});

export default withSetsSearch(
  withTableName(
    withOnline(
      withGoBack(
        withForm(
          withNotify(
            withLoader(
              ExpressCareSets
            )
          )
        )
      )
    )
  )
);
